import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Select from 'react-select';

import Utils from '../../../Services/Utils';

import InputWrapper from '../WrapperInput';
import withShallowComparison from '../../Common/withShallowComparisonUpdate';

import './style.scss';

class InputSelect extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  componentDidMount() {
    this.initValidate();
  }

  componentDidUpdate() {
    this.initValidate();
  }

  initValidate = () => {
    const { value, onError, error } = this.props;
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  }

  _getValueMultiple = (value, options) => {
    let result = [];
    value.forEach((item) => {
      if (options) {
        let valueAux = !Utils.isNull(item.value) ? item.value : item;
        options.forEach((option) => {
          if (option.value == valueAux) {
            result.push(option);
          }
        });
      }
    });
    return result;
  };

  _getValueNormal = (value, options) => {
    let result = null;
    if (options) {
      options.forEach((option) => {
        let valueAux = !Utils.isNull(value.value) ? value.value : value;
        if (option.value == valueAux) {
          result = option;
        }
      });
    }
    return result;
  };

  _getValue = (options, value) => {
    let result = null;
    if (Array.isArray(value)) {
      result = this._getValueMultiple(value, options);
    }
    else {
      result = this._getValueNormal(value, options);
    }
    return result;
  };

  getValueObject = (value) => {
    const { options, multiple } = this.props;
    let result = null;
    if (multiple) {
      result = (Array.isArray(value) ? (Object.assign([], value)) : (Utils.isObject(value) ? [value] : value.split(',')));
    }
    else {
      result = (Utils.isObject(value) ? Object.assign({}, value) : value.toString());
    }
    return this._getValue(options, result);
  };

  validate = (value) => {
    const { required, validators } = this.props;
    var result = null;
    if (Array.isArray(value)) {
      result = [];
      value.forEach((item) => {
        const itemValue = Utils.isObject(item) ? item.value : item;
        if (!Utils.isNull(itemValue)) {
          result.push(Utils.isObject(item) ? item.value : item);
        }
      });
    }
    else {
      result = Utils.isObject(value) ? value.value : value;
    }
    if (required && Utils.isEmpty(result)) {
      return 'This field is required.';
    }
    for (const validator of validators || []) {
      if (validator(result)) return validator(result);
    }
    return '';
  };

  handleChange = (e) => {
    const {onChange, onError, error, value, multiple } = this.props;
    let newValue = e && e.target ? e.target.value : e;
    const oldValue = Utils.isObject(value) ? value.value?.toString() : value;
    if (!multiple) {
      const newValueFormatted = Utils.isObject(newValue) ? newValue.value?.toString() : newValue;
      if (oldValue == newValueFormatted) {
        newValue = { label:'', value: null };
      }
    }
    else {
      if (oldValue == newValue) {
        newValue = { label:'', value: null };
      }
    }
    if (onChange) onChange(newValue);
    const newError = this.validate(newValue);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  };

  openElement = () => {
    this.setState({
      open: true
    });
    document.addEventListener("mousedown", this.handleOutsideClicks);
  };

  closeElement = () => {
    this.setState({
      open: false
    });
    document.removeEventListener('mousedown',this.handleOutsideClicks);
  };

  handleOutsideClicks =(event)=>{
    this.setState({
    open: false
  });
    document.removeEventListener('mousedown',this.handleOutsideClicks);
};

  render() {
    const {
      className,
      label,
      labelhtml,
      error,
      placeholder,
      disabled,
      multiple,
      required,
      options,
      value,
      defaultValue,
      isClearable,
    } = this.props;

    const WrapperProps = {
      className,
      label,
      labelhtml,
      error,
      required,
    };

    let valueSelect = null;
    if (!Utils.isNull(value)) {
      valueSelect = (Utils.isNull(value.value) ? this.getValueObject(value) : value);
    } else if (!Utils.isNull(defaultValue)) {
      valueSelect = defaultValue;
    }

    return (
      <InputWrapper { ...WrapperProps }>
        <Select { ...this.props }
          options={ options }
          value={ valueSelect }
          onChange={ this.handleChange }
          isDisabled={ disabled }
          isMulti={ multiple }
          required={ required }
          className={ classNames('Select', {
            Select_Disabled: Boolean(disabled),
            Select_Active: Boolean(this.state.open),
          }) }
          onMenuOpen={ this.openElement }
          onMenuClose={ this.closeElement }
          placeholder={ placeholder }
          isClearable={isClearable}
          menuIsOpen={this.state.open}
        />
      </InputWrapper>
    );
  }
}

InputSelect.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.array,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  onError: PropTypes.func,
  isClearable: PropTypes.bool,
};

export default withShallowComparison(InputSelect, ['onChange', 'onError']);